import React from 'react';
import BoxViewer from '../BoxViewer';
import { EditorViewWrapper } from './EditorView.styles';

interface EditorViewProps {}

const EditorView: React.FC<EditorViewProps> = () => (
  <EditorViewWrapper>
    <BoxViewer />
  </EditorViewWrapper>
);

export default EditorView;
